export default "__VITE_ASSET__D9pyEx8a__"